import { DATA_FETCHING_CANCELED, DATA_FETCHING_COMPLETED } from 'features';
import { getVisibility } from 'features/page-model/ducks/get-model';
import { getDisplayedName } from 'features/product-info';
import { put, select, takeEvery } from 'redux-saga/effects';
import logger from 'loglevel';
import { ERROR_404_NOT_FOUND, ERROR_500_INTERNAL_SERVER_ERROR } from './actions';

export function* runErrorDetector() {
  yield takeEvery(DATA_FETCHING_COMPLETED, function* handle() {
    const visibility: boolean | null = (yield select(getVisibility)) ?? null;
    const displayedName: string | null = (yield select(getDisplayedName)) ?? null;

    if (visibility === false) {
      yield put(ERROR_404_NOT_FOUND('Visibility is false'));
    } else if (!displayedName || visibility === null) {
      logger.error('Critical error at SSR. There has no required data: ', { visibility, displayedName });
      yield put(ERROR_500_INTERNAL_SERVER_ERROR('There has no required data'));
    }
  });

  yield takeEvery(DATA_FETCHING_CANCELED, function* handle() {
    yield put(ERROR_404_NOT_FOUND('Pathname corrupted. Data fetching was cancelled'));
  });
}
